import React from 'react';
import { ArrowLeft } from 'lucide-react';
interface DatenschutzPageProps {
  onBack: () => void;
}
export function DatenschutzPage({
  onBack
}: DatenschutzPageProps) {
  return <div className="min-h-screen bg-white py-12 px-4 sm:px-6 lg:px-8" data-id="element-454">
      <div className="max-w-3xl mx-auto" data-id="element-455">
        <button onClick={onBack} className="flex items-center text-slate-500 hover:text-brand-500 transition-colors mb-8 group" data-id="element-456">
          <ArrowLeft className="w-4 h-4 mr-2 group-hover:-translate-x-1 transition-transform" data-id="element-457" />
          Zurück zur Startseite
        </button>

        <h1 className="text-3xl md:text-4xl font-serif font-bold text-slate-900 mb-8" data-id="element-458">
          Datenschutzerklärung
        </h1>

        <div className="prose prose-slate max-w-none text-slate-600" data-id="element-459">
          <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4" data-id="element-460">
            1. Datenschutz auf einen Blick
          </h2>
          <h3 className="text-lg font-bold text-slate-800 mt-4 mb-2" data-id="element-461">
            Allgemeine Hinweise
          </h3>
          <p data-id="element-462">
            Die folgenden Hinweise geben einen einfachen Überblick darüber, was
            mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website
            besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie
            persönlich identifiziert werden können.
          </p>

          <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4" data-id="element-463">
            2. Hosting
          </h2>
          <p data-id="element-464">
            Wir hosten die Inhalte unserer Website bei einem externen Anbieter
            (Hoster). Die personenbezogenen Daten, die auf dieser Website
            erfasst werden, werden auf den Servern des Hosters gespeichert.
            Hierbei kann es sich v. a. um IP-Adressen, Kontaktanfragen, Meta-
            und Kommunikationsdaten, Vertragsdaten, Kontaktdaten, Namen,
            Webseitenzugriffe und sonstige Daten, die über eine Website
            generiert werden, handeln.
          </p>

          <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4" data-id="element-465">
            3. Allgemeine Hinweise und Pflichtinformationen
          </h2>
          <h3 className="text-lg font-bold text-slate-800 mt-4 mb-2" data-id="element-466">
            Datenschutz
          </h3>
          <p data-id="element-467">
            Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen
            Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten
            vertraulich und entsprechend den gesetzlichen
            Datenschutzvorschriften sowie dieser Datenschutzerklärung.
          </p>

          <h3 className="text-lg font-bold text-slate-800 mt-4 mb-2" data-id="element-468">
            Hinweis zur verantwortlichen Stelle
          </h3>
          <p data-id="element-469">
            Die verantwortliche Stelle für die Datenverarbeitung auf dieser
            Website ist: Nuviora UG (haftungsbeschränkt) Cosimastraße 121
            München, 81925 Deutschland
          </p>

          <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4" data-id="element-470">
            4. Datenerfassung auf dieser Website
          </h2>
          <h3 className="text-lg font-bold text-slate-800 mt-4 mb-2" data-id="element-471">
            Cookies
          </h3>
          <p data-id="element-472">
            Unsere Internetseiten verwenden so genannte „Cookies“. Cookies sind
            kleine Textdateien und richten auf Ihrem Endgerät keinen Schaden an.
            Sie werden entweder vorübergehend für die Dauer einer Sitzung
            (Session-Cookies) oder dauerhaft (permanente Cookies) auf Ihrem
            Endgerät gespeichert.
          </p>

          <h3 className="text-lg font-bold text-slate-800 mt-4 mb-2" data-id="element-473">
            Kontaktformular
          </h3>
          <p data-id="element-474">
            Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden
            Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort
            angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den
            Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir
            nicht ohne Ihre Einwilligung weiter.
          </p>

          <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4" data-id="element-475">
            5. Analyse-Tools und Werbung
          </h2>
          <p data-id="element-476">
            Soweit Sie eingewilligt haben, werden auf dieser Website
            Analyse-Tools (z.B. Google Analytics) eingesetzt, um das
            Nutzerverhalten auszuwerten und unser Angebot zu verbessern.
          </p>

          <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4" data-id="element-477">
            6. Newsletter
          </h2>
          <p data-id="element-478">
            Wenn Sie den auf der Website angebotenen Newsletter beziehen
            möchten, benötigen wir von Ihnen eine E-Mail-Adresse sowie
            Informationen, welche uns die Überprüfung gestatten, dass Sie der
            Inhaber der angegebenen E-Mail-Adresse sind und mit dem Empfang des
            Newsletters einverstanden sind.
          </p>
        </div>
      </div>
    </div>;
}